import { html, LitElement } from 'lit';
import {
  timeIntervalsToCalendarEvents,
} from '../../../lib/time-interval-openings-converter.js';

class D1iOpeningHoursStatus extends LitElement {
  static get is() {
    return 'd1i-opening-hours-status';
  }

  static get properties() {
    return {
      timeIntervalOpenings: {
        type: Array,
        attribute: 'time-interval-openings',
      },
      isOpen: {
        type: Boolean,
        attribute: 'open',
        reflect: true,
      },
      isCurrentException: {
        type: Boolean,
        attribute: 'is-current-exception',
        reflect: true,
      },
    };
  }

  constructor() {
    super();
    this.isOpen = false;
    this.isCurrentException = false;
    this.timeIntervalOpenings = {};
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.timeIntervalOpenings.length === 0) {
      return;
    }
    this._updateStatus();
    this.interval = setInterval(() => this._updateStatus(), 60000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    return html`
    ${this.isOpen
    ? html`<slot name="is-open-content"></slot>`
    : html`<slot name="is-closed-content"></slot>`
}`;
  }

  _updateStatus() {
    if (this.isCurrentException) {
      this.isOpen = false;
      return;
    }

    const calendarEvents = timeIntervalsToCalendarEvents(this.timeIntervalOpenings);
    for (const event of calendarEvents) {
      if (event.isActive(new Date())) {
        this.isOpen = true;
        return;
      }
    }
    this.isOpen = false;
  }
}

customElements.define(D1iOpeningHoursStatus.is, D1iOpeningHoursStatus);
